var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_3356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56517 2.99829C3.70108 2.99829 3 3.71116 3 4.58869V5.52473C3 6.17476 3.24719 6.79987 3.68936 7.27006L8.5351 12.4226L8.53723 12.4194C9.47271 13.3771 9.99905 14.6717 9.99905 16.0216V20.5935C9.99905 20.899 10.3187 21.094 10.584 20.9499L13.3436 19.4462C13.7602 19.2187 14.0201 18.7766 14.0201 18.2967V16.0097C14.0201 14.6674 14.539 13.3782 15.466 12.4226L20.3117 7.27006C20.7528 6.79987 21 6.17476 21 5.52473V4.58869C21 3.71116 20.3 2.99829 19.4359 2.99829H4.56517Z",
    stroke: "url(#paint0_linear_44_3356)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_3356",
    x1: 12,
    y1: 2.99829,
    x2: 8.37302,
    y2: 18.9567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E68FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6691FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_3356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 -0.00170898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSvg);
export default __webpack_public_path__ + "static/media/FilterSVG.6cc6982f8436cb02b118ed63804c95e4.svg";
export { ForwardRef as ReactComponent };